/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "wruCWicGBA4",
    title: "15 Minute Meditation Music, Relaxing Music",
    category: "Meditation",
    channelName: "Yellow Brick Cinema ",
    dateOfUpload: "Jun 27, 2018",
    description:
      "Our relaxing music is perfect for Buddhist meditation, Zen meditation, Mindfulness meditation. This music is influenced by Japanese meditation music, Indian meditation music, Tibetan music and Shamanic music. Some benefits include cleansing the Chakra, opening the Third Eye and increasing Transcendental meditation skills. The work of Byron Katie, Sedona Method, Silva Method and the Secret highlights the fact that healing can occur through using the mind and being in the “now”. Healing Meditation can be practised using this music for best results.",
  },
  {
    _id: "inpok4MKVLM",
    title: "5-Minute Meditation You Can Do Anywhere",
    category: "Meditation",
    channelName: "Goodful",
    dateOfUpload: "Sep 4, 2019",
    description:
      "Our relaxing music is perfect for Buddhist meditation, Zen meditation, Mindfulness meditation. This music is influenced by Japanese meditation music, Indian meditation music, Tibetan music and Shamanic music. Some benefits include cleansing the Chakra, opening the Third Eye and increasing Transcendental meditation skills. The work of Byron Katie, Sedona Method, Silva Method and the Secret highlights the fact that healing can occur through using the mind and being in the “now”. Healing Meditation can be practised using this music for best results.",
  },
  {
    _id: "Hzi3PDz1AWU",
    title: "How to Meditate' for Beginners | Sadhguru",
    category: "Meditation",
    channelName: "Sadhguru ",
    dateOfUpload: "Oct 30, 2021",
    description:
      "Sadhguru goes in depth about what meditation really is and clarifies common misunderstandings that meditation is a practice.Yogi, mystic and visionary, Sadhguru is a spiritual master with a difference.",
  },
  {
    _id: "s2NQhpFGIOg",
    title: "15 Min Daily Yoga Routine for Beginners",
    category: "Yoga",
    channelName: "Fit Tuber",
    dateOfUpload: "Mar 20, 2020",
    description:
      "This is a 15 minute beginner’s daily yoga routine. With gyms and offices shutting down, this video is focussed on utilising our precious time into a higher purpose of learning yoga. If you have never practised any of the yogic postures or breathing exercises then this should be the video which will help you get started with this divine practice. Let’s not focus on the fear, panic and the noise created by the media instead channelise our energy into something like yoga which will boost your immunity and help you live a disease free life in the long run",
  },
  {
    _id: "Eml2xnoLpYE",
    title: "Full Body Yoga for Strength & Flexibility",
    category: "Yoga",
    channelName: "growingannanas",
    dateOfUpload: "Nov 5, 2020",
    description:
      "Tabata is an advanced level of the workout and is not suitable for beginners. If you are a newbie start with simple and easy exercise before attempting Tabata. Performing Tabata, in the beginning, might strain your muscles and you may get injured.",
  },
  {
    _id: "c8hjhRqIwHE",
    title: "Yoga For Beginners :Part 1 | Yoga Routine",
    category: "Yoga",
    channelName: "cultfitOfficial ",
    dateOfUpload: " May 11, 2021",
    description:
      "This Yoga Video from Cult Fit is the perfect workout for beginners to start your day. Say yes to healthy living with Cult Fit",
  },
  {
    _id: "1ZYbU82GVz4",
    title: "Relaxing Sleep Music • Deep Sleeping Music",
    category: "Sleep",
    channelName: "Soothing Relaxation",
    dateOfUpload: "Jul 3, 2016",
    description:
      "Relaxing sleep music for deep sleeping and stress relief. Fall asleep to beautiful nature videos and use the relaxing music as sleeping music, soothing meditation music, relaxation music, study music and more.",
  },
  {
    _id: "bP9gMpl1gyQ",
    title: "Relaxing Sleep Music + Insomni",
    category: "Sleep",
    channelName: "The Soul of Wind",
    dateOfUpload: "Apr 11, 2020",
    description:
      "Relaxing sleep music for deep sleeping and stress relief. Fall asleep to beautiful nature videos and use the relaxing music as sleeping music, soothing meditation music, relaxation music, study music and more.",
  },
  {
    _id: "mXw2aAforhg",
    title: "BRAIN CALMING MUSIC || Stress Relief & Nerve Regeneration",
    category: "Stress Relief and Relaxing",
    channelName: "Meditative Mind ",
    dateOfUpload: "Jan 23, 2018",
    description:
      "Let Go Anxieties and Negative Thoughts with this Soothing, Smooth and Deep - Brain Calming Music.  If you are feeling mentally drained or stressed out, Meditate and let this play in the background.  You can also lie down and listen to this while you drift into Peaceful Sleep. ",
  },
  {
    _id: "QjDnjoaUJtI",
    title: "Soothing Music for Anxiety & Stress Relief ",
    category: "Stress Relief and Relaxing",
    channelName: "Sleep Easy Relax ",
    dateOfUpload: "Dec 31, 2020",
    description:
      "The music has been designed using chakra healing frequencies as well as deep Delta Brain Waves, and hence it can help in restoring the Positive Energy Flow in and around you, Enhance Mood and calm the overall stress level, and reduce headaches.",
  },
];
